<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("productioncompany", 2) }}</div>
        <div class="section-subTitle my-2">{{ $t("production_dash_msg") }}</div>
      </div>
      <div>
        <b-button variant="default" to="add-production" class="btn-blue">{{
          $tc("add")
        }}</b-button>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getProductionList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="Production.length > 0"
        v-for="(item, key) in Production"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.production_name, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  @click="goToRoute('/master/edit-production', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/master/view-production', item)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <!-- <label class="ios-switch">
                <input
                  v-model="item.production_is_active"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="item.production_is_active ? 'active' : 'inactive'"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="Production.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th>
            <img
              v-if="this.columnName != 'production_name'"
              @click="onSortValue('production_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('production_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('production_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("production", 1) }}
          </th>
          <th class="text-right">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="Production.length > 0">
        <tr v-for="(item, key) in Production" :key="key">
          <td>{{ $tc(item.production_name, 1) }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <!-- <label class="ios-switch">
                <input
                  v-model="item.production_is_active"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>

              </label> -->
              <StatusDot
                :status="item.production_is_active ? 'active' : 'inactive'"
              />
              <div>
                <b-dropdown right variant="edit">
                  <b-dropdown-item
                    @click="goToRoute('/master/edit-production', item)"
                  >
                    <span class="edit-pen mr-1"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="goToRoute('/master/view-production', item)"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="Production.length == 0">
        <tr>
          <td colspan="2">
            <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-if="Production.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Production from "@/helper/formJSONMaster/Production";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import StatusDot from "@/components/Partials/StatusDot.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: Production.Methods,
      Production: [],
      viewingnumbers: [],
      customErrors: {
        message: ""
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      searchKey: "production_name"
    };
  },
  beforeMount() {
    this.getProductionList();
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getProductionList();
      } else {
        this.currentPage = event;
        this.getProductionList();
      }
    },
    goToRoute: function(path, item) {
      console.log("item :", item);
      const { production_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: production_id
        }
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getProductionList();
    },
    getProductionList: function() {
      this.Production = [];
      let body = this.getRequestBody("GET", undefined, this.Methods);
      body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}&orderBy=${this.orderby}&columnName=${this.columnName}&searchValue=${this.searchValue}&searchKey=${this.searchKey}`;
      console.log("body :", body);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Production = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ProductionCompany/production.vue